/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import React, { useEffect, useMemo, useState } from "react";

import { fetchScrollPrices } from "../api";

export default function PriceScroller() {

    const [prices, setPrices] = useState([]);

    useEffect(() => {

        const fetchPrices = async () => {

            try {

                const data = await fetchScrollPrices();

                setPrices(data || []);

            } catch (error) {

                console.error(
                    "Error fetching stock prices:",
                    error
                );
            }
        };

        fetchPrices();

        const interval = setInterval(
            fetchPrices,
            15000
        );

        return () => clearInterval(interval);

    }, []);

    /*
     Duplicate data for seamless infinite scrolling
    */

    const tickerData = useMemo(() => {

        return [...prices, ...prices];

    }, [prices]);

    return (

        <div className="
            w-full
            overflow-hidden
            border-b
            border-zinc-800
            bg-zinc-900
        ">

            <div className="
                flex
                whitespace-nowrap
                animate-[ticker_40s_linear_infinite]
                hover:[animation-play-state:paused]
                py-2
            ">

                {tickerData.length > 0 ? (

                    tickerData.map((stock, index) => (

                        <div
                            key={index}
                            className="
                                flex
                                items-center
                                px-8
                                text-sm
                                shrink-0
                            "
                        >

                            {/* Pulse Dot */}

                            <div
                                className={`
                                    w-2
                                    h-2
                                    rounded-full
                                    mr-3
                                    ${
                                        stock.change_percent >= 0
                                            ? "bg-emerald-400"
                                            : "bg-red-400"
                                    }
                                `}
                            />

                            {/* Symbol */}

                            <span className="
                                text-zinc-100
                                font-semibold
                                mr-3
                            ">

                                {stock.symbol}

                            </span>

                            {/* Price */}

                            <span className="
                                text-zinc-300
                                mr-2
                            ">

                                ₹{stock.last_price}

                            </span>

                            {/* Change */}

                            <span
                                className={`
                                    font-medium
                                    ${
                                        stock.change_percent >= 0
                                            ? "text-emerald-400"
                                            : "text-red-400"
                                    }
                                `}
                            >

                                {stock.change_percent > 0 ? "+" : ""}
                                {stock.change_percent.toFixed(2)}%

                            </span>

                        </div>

                    ))

                ) : (

                    <div className="
                        px-8
                        py-1
                        text-sm
                        text-zinc-400
                    ">

                        Loading market prices...

                    </div>

                )}

            </div>

        </div>
    );
}